import React from 'react';

import '../css/product-rating.less';

const ProductRating = ({ rating })=> {
    return <span className={`stars-sprite rating-v2-${60*Math.round(rating/.5)*.5}`} style={{backgroundPositionY: -300*Math.round(rating*10)/10}}></span>
};

export default ProductRating;
